// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Layout from '@/components/Layout';
import Backend from '@/Backend';
import VueYouTubeEmbed from 'vue-youtube-embed';
import JsonEditor from 'vue-json-edit'

Vue.use(JsonEditor)
Vue.use(VueYouTubeEmbed);

Vue.component('layout', Layout);

Vue.config.productionTip = false;

new Backend();

const vue = new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
});










// WEBPACK FOOTER //
// ./src/main.js